import { useTranslation } from "react-i18next";
import { TopNav } from "../components/nav/TopNav";
import { HeroCarousel } from "../components/common/HeroCarousel";
import { TaggedExamples } from "./HomePage/TaggedExamples";
import "./HomePage/HomePage.less";
import "./AboutPage.less";

export function AboutPage() {
  const { t } = useTranslation("legal");

  return (
    <div className="about-page">
      <section className="about-hero" data-testid="about-hero">
        <HeroCarousel folder="about" />
        <div className="about-hero__scrim" />
        <TopNav overlay />
        <div className="about-hero__inner">
          <div className="about-hero__content">
            <p className="about-hero__eyebrow">{t("about.eyebrow")}</p>
            <h1
              className="about-hero__title"
              dangerouslySetInnerHTML={{ __html: t("about.headline") }}
            />
          </div>
        </div>
      </section>

      <section className="about-story">
        <div className="about-story__inner">
          <p className="about-story__eyebrow">{t("about.storyEyebrow")}</p>
          <h2 className="about-story__headline">{t("about.storyHeadline")}</h2>
          <div className="about-story__grid">
            <div className="about-story__text">
              <p>{t("about.intro1")}</p>
              <p>{t("about.intro2")}</p>
            </div>
            <div className="about-story__photo-wrap">
              <img
                className="about-story__photo"
                src="/usa-df.jpeg"
                alt={t("about.photoAlt")}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="about-trips">
        <div className="about-trips__inner">
          <p className="about-trips__eyebrow">{t("about.tripsEyebrow")}</p>
          <h2 className="about-trips__headline">{t("about.tripsHeadline")}</h2>
          <TaggedExamples tag="about" />
        </div>
      </section>

      <section className="about-cta">
        <div className="about-cta__inner">
          <h2 className="about-cta__headline">{t("about.ctaHeadline")}</h2>
          <p className="about-cta__text">{t("about.ctaText")}</p>
          <a className="about-cta__email" href={`mailto:${t("about.ctaEmail")}`}>
            {t("about.ctaEmail")}
          </a>
        </div>
      </section>
    </div>
  );
}
